import { render, staticRenderFns } from "./_flat.table.vue?vue&type=template&id=352c26f2&scoped=true"
import script from "./_flat.table.vue?vue&type=script&lang=js"
export * from "./_flat.table.vue?vue&type=script&lang=js"
import style0 from "./_flat.table.vue?vue&type=style&index=0&id=352c26f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352c26f2",
  null
  
)

export default component.exports